import React, {Component} from 'react';
import PropTypes from 'prop-types';

class Cart extends Component {
  render() {

    let number = 0;

    if (this.props.cart.length !== 0) {
      this.props.cart[0].order_items.forEach(item => number += parseInt(item.quantity, 10))
    }

    let cartItems = `${number}`;

    return (
    <div id="block-cart" className="block block-commerce-cart cart">
      <div className={`cart--cart-block ${number > 0 ? "something-in" : ""}`}>
        <div className="cart-block--summary">
          <a className="cart-block--link__expand" href="/cart">
              <span className="cart-block--summary__icon">
                {number === 0 &&
                <img src="/themes/custom/module_box/src/images/Wagen-on.svg" alt="search"/>
                }
                {number > 0 &&
                <svg version="1.1" id="Ebene_1"
                     xmlns="http://www.w3.org/2000/svg"
                     xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 62.59 50.88"
                     style={{enableBackground:"new 0 0 62.59 50.88", width: "60px", marginTop: "-10px"}}
                     xmlSpace="preserve">
                  <g id="Gruppe_1655" transform="translate(-2573.188 265.144)">
                  <path style={{ fill: "#012332" }} id="Pfad_969" className="st0" d="M2618.56-245.57c-0.2-0.42-0.57-0.75-1.01-0.9c-0.19-0.07-0.38-0.1-0.58-0.1h-28.05
                    c-0.09,0-0.18-0.06-0.2-0.15l-0.42-2.14l-1.04-3.9c-0.21-0.77-0.91-1.31-1.71-1.32h-10.59c-0.98,0-1.77,0.79-1.77,1.77v1.83
                    c0,0.98,0.79,1.77,1.77,1.77h7.67c0.09,0,0.18,0.06,0.2,0.15l0.42,2.14l5.98,22.42c0.21,0.78,0.91,1.32,1.71,1.32h18.98
                    c0.75,0,1.43-0.48,1.67-1.19l7.05-20.35C2618.79-244.66,2618.76-245.15,2618.56-245.57z M2611.82-240.99c0,0.02,0,0.05-0.01,0.07
                    l-4.41,12.74c-0.03,0.09-0.11,0.14-0.2,0.14h-13.35c-0.09,0-0.18-0.06-0.2-0.15l-3.4-12.74c-0.03-0.11,0.04-0.22,0.15-0.25
                    c0.02,0,0.03-0.01,0.05-0.01h21.16c0.05,0,0.11,0.02,0.15,0.06C2611.8-241.1,2611.82-241.05,2611.82-240.99L2611.82-240.99z"/>
                                    <circle id="Ellipse_82" className="st0" cx="2591.25"
                                            cy="-218.03" r="3.77"/>
                                    <circle id="Ellipse_83" className="st0" cx="2607.11"
                                            cy="-218.03" r="3.77"/>
                </g>
                  <circle style={{ fill: "#fff" }}  id="Ellipse_84" className="st1" cx="51.59" cy="11" r="11" />
                  <text style={{ fill: '#012332', color: '#012332' }} x="82%" y="22%" textAnchor="middle" stroke="#000" strokeWidth="2px" dy=".3em">{cartItems}</text>
                </svg>
                }

              </span>
          </a>
        </div>
      </div>
    </div>
    );
  }
}

Cart.propTypes = {
  cart: PropTypes.array.isRequired
};

export default Cart;
